// extracted by mini-css-extract-plugin
export default {"container":"WhyUs_container__iWdow","heading":"WhyUs_heading__DzFdo","why":"WhyUs_why__Sxvv5"};